const payrollSummary = {
  path: '/payrollSummary',
  name: 'payrollSummary',
  component: () =>
    import(
      /* webpackChunkName: "payroll_summary" */ '@/components/payrollSummary/PayrollSummaryIndex.vue'
    ),
  children: [
    {
      path: 'view/:id',
      component: () =>
        import(
          /* webpackChunkName: "payroll_summary" */ '@/components/payrollSummary/PayrollSummaryView.vue'
        ),
      name: 'payrollSummaryView',
    },
    {
      path: 'edit/:id',
      component: () =>
        import(
          /* webpackChunkName: "payroll_summary" */ '@/components/payrollSummary/PayrollSummaryEdit.vue'
        ),
      name: 'payrollSummaryEdit',
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "payroll_summary" */ '@/components/payrollSummary/PayrollSummaryCreate.vue'
        ),
      name: 'payrollSummaryCreate',
    },
  ],
  meta: { authorize: [], requiresAuth: true },
};

export default payrollSummary;
